import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "@phosphor-icons/react";

const PaymentCancel = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-[calc(100vh-4rem)] grid place-items-center px-4">
      <div className="bg-card border border-border rounded-2xl p-8 text-center max-w-md w-full">
        <XCircle size={56} weight="fill" className="mx-auto text-muted-foreground" />
        <h1 className="font-heading text-2xl font-bold mt-4">Pagamento annullato</h1>
        <p className="text-muted-foreground mt-2">Nessun addebito effettuato. Puoi riprovare quando vuoi.</p>
        <Button className="rounded-full mt-6 w-full" data-testid="cancel-back" onClick={() => navigate("/search")}>Torna a esplorare</Button>
      </div>
    </div>
  );
};

export default PaymentCancel;
